import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams, useOutletContext, useSearchParams, useLocation } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import ProductCard from "./../component/ProductCard";
import ProductCardSkeleton from "./../component/ProductCardSkeleton";
import HeadingSkeleton from "./../component/HeadingSkeleton";
import $ from "jquery";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";

const fairbanner = require("./../assets/img/fair-banner.png");
const logo = require("./../assets/img/puma-logo.png");
const wishlistImg = require("./../assets/img/wishlist-icon2.svg").default;
const cartImg = require("./../assets/img/cart-icon.svg").default;

const FairTradeProducts = () => {
  // Sidebar filter UI state
  const [expandedGroups, setExpandedGroups] = useState({ categories: true, product_categories: true, seasons: true, prices: true });
  const [searchProductType, setSearchProductType] = useState('');
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const { storeId, proCatId } = useParams();
  const location = useLocation();
  const [showFilters, setShowFilters] = useState(false);
  const [isWebView, setIsWebView] = useState(window.innerWidth > 1299);
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') || '';

  // Determine category from current route
  const getDefaultCategory = () => {
    const pathname = location.pathname;
    if (pathname.includes('/bestsellers')) return 'bestsellers';
    if (pathname.includes('/new')) return 'new';
    if (pathname.includes('/sale')) return 'sale';
    return 'bestsellers';
  };

  // Get store context from StoreLayout
  const outletContext = useOutletContext();
  const store = outletContext?.store;
  const isWishlisted = outletContext?.isWishlisted;
  const favouriteId = outletContext?.favouriteId;

  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [category, setCategory] = useState("default"); // default category
  const [sortKey, setSortKey] = useState("default"); // default sort key
  const [allDetails, setAllDetails] = useState();
  const [wishBtn, setWishBtn] = useState(false);
  const [wishMsg, setWishMsg] = useState(false);
  const [openModal, setOpenModal] = useState();
  const [activeImage, setActiveImage] = useState();
  const [loading, setLoading] = useState(true);

  const [availableFilters, setAvailableFilters] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({
    store_id: storeId,
    category: getDefaultCategory(),
    categories: [],
    product_categories: [],
    seasons: [],
    prices: [],
    min_price: "",
    max_price: "",
    search_term: "",
    sort_key: "newest_first"
  });



  const toggleCategory = (catId) => {
    setAppliedFilters(f => {
      let updated;
      if (!f.categories.includes(catId)) {
        updated = [...f.categories, catId];
      } else {
        updated = f.categories.filter((id) => id !== catId);
      }
      setSelectedCategories(updated);
      return { ...f, categories: updated };
    });
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}frontend/store/products`, {
        method: "POST",
        body: JSON.stringify({
          ...appliedFilters,
          lang: selectedLanguage,
          user_id: user?.id,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      setProducts(data.data.products);
      setAllDetails(data.data);
      setAvailableFilters(data.data.available_filters);
      // Do NOT reset appliedFilters here, so user selections persist
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddWishlist = async (productId) => {
    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
    } else {
      setWishMsg(null);
      setWishBtn(true);
      try {
        const response = await fetch(`${API_BASE_URL}frontend/wishlists`, {
          method: "POST",
          body: JSON.stringify({
            product_id: productId,
            lang: selectedLanguage,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.authorisation?.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          setWishMsg(responseData.msg);
          setWishBtn(false);
        } else {
          setWishMsg(responseData.msg);
          setWishBtn(false);
        }
        setTimeout(() => {
          setWishMsg(null);
        }, 5000);
      } catch (error) {
        console.error("Error during Sign UP:", error);
        setWishBtn(false);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [user, appliedFilters]);

  useEffect(() => {
    const handleResize = () => {
      setIsWebView(window.innerWidth > 1299);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Update category when URL changes
  useEffect(() => {
    const category = getDefaultCategory();
    setAppliedFilters(f => ({ ...f, category }));
  }, [location.pathname]);

  useEffect(() => {
    let filtered = products;

    // Apply search filter
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter((product) =>
        product.title?.toLowerCase().includes(query) ||
        product.description?.toLowerCase().includes(query)
      );
    }

    setFilteredProducts(filtered);
  }, [appliedFilters.categories, products, searchQuery]);

  const navigate = useNavigate();

  const getCategoryLabel = () => {
    switch (appliedFilters.category) {
      case 'bestsellers':
        return langJson?.bestsellers ?? 'Bestsellers';
      case 'new':
        return langJson?.new ?? 'New';
      case 'sale':
        return langJson?.sale ?? 'Sale';
      default:
        return langJson?.bestsellers ?? 'Bestsellers';
    }
  };

  const handleCategoryChange = (newCategory) => {
    setAppliedFilters(f => ({ ...f, category: newCategory }));
    navigate(`/stores/${storeId}/${newCategory}`);
  };

  return (

    <div className="categoryDiv productSliderMain topNew tradePrdts">
      <div className="fullContainer">
        {loading ? (
          <HeadingSkeleton width="200px" height="28px" />
        ) : (
          <h3 className="storeTabHdn">{searchQuery ? `Search results for "${searchQuery}"` : getCategoryLabel()}</h3>
        )}



        <div style={{ float: 'left', display: 'flex', gap: '20px' }}>
          {/* Products Grid */}
          <div className="featureDiv productListMain" style={{ flex: 1 }}>

            <div className="productList">
              <ul className={`products responsiveSliderGrid ${isWebView ? (showFilters ? 'products-5-col' : 'products-6-col') : ''}`}>
                {loading ? (
                  Array.from({ length: 12 }).map((_, index) => (
                    <ProductCardSkeleton key={index} />
                  ))
                ) : filteredProducts && filteredProducts.length > 0 ? (
                  filteredProducts.map((product) => (
                    <ProductCard
                      key={product.order_no}
                      product={product}
                      handleAddWishlist={handleAddWishlist}
                      isStoreView={true}
                      hideTag={true}
                    />
                  ))
                ) : (
                  <div className="noItemFoundClass">{langJson?.noitemsfound}</div>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default FairTradeProducts;
